import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import classes from './DataTable.module.scss';
import _ from "lodash"
import TextField from '@mui/material/TextField';

const DataTable = ({ title, columns, rows, fetchData, params, isLoading, rowCount }) => {

  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value !== null) {
        fetchData(params.sortOrder, params.sortBy, 0, params.pageSize, value)
      } else if (value === '') {
        fetchData(params.sortOrder, params.sortBy, 0, params.pageSize, value)
      }
    }, 1000);

    debouncedHandler(inputValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [inputValue]);

  useEffect(() => {
    console.log(isLoading);
  }, [isLoading])

  const handleChange = event => {
    setInputValue(event.target.value);
  };

  const handlePaginationModelChange = (e) => {
    if (e.pageSize === params.pageSize) fetchData(params.sortOrder, params.sortBy, e.page, e.pageSize, params.search)
    else fetchData(params.sortOrder, params.sortBy, 0, e.pageSize, params.search)
  }

  return (
    <div className={classes.tableCard}>
      <div className={classes.title}>
        {title}
        <div>
          <TextField
            id="standard-search"
            label="Search"
            type="search"
            variant="outlined"
            disabled={isLoading}
            onChange={handleChange}
          />
        </div>
      </div>
      <div style={{ width: '100%', overflowX: 'auto' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowHeight={() => "auto"}
          autoHeight={true}
          initialState={{
            pagination: {
              paginationModel: { page: params.page, pageSize: params.pageSize },
            },
            sorting: {
              sortModel: [{ field: params.sortBy, sort: params.sortOrder}]
            }
          }}
          pageSizeOptions={[10, 50, 100]}
          rowCount={+rowCount}
          density="comfortable"
          disableRowSelectionOnClick={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          disableColumnSelector={true}
          disableDensitySelector={true}
          sortingOrder={['asc', 'desc']}
          sortingMode="server"
          paginationMode="server"
          onPaginationModelChange={handlePaginationModelChange}
          paginationModel={{page: params.page, pageSize: params.pageSize}}
          onSortModelChange={(e) => {console.log(e); fetchData(e[0].sort, e[0].field, 0, params.pageSize, params.search); }}
          loading={isLoading}
          sx={{fontFamily: 'Poppins'}}
        />
      </div>
    </div>
  );
}

export default DataTable